export default [
  {
    component: () => import('@/modules/askkeelearning/views/AskKeelearningResult.vue'),
    name: 'result',
    path: '/ask-keelearning/result',
    meta: {
      noSidebar: true,
      askKeelearningBackground: true,
      requiresModule: 'ask_keelearning',
      fullContent: true,
    },
  },
]
